import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, ChevronLeft, Network, MonitorSmartphone, GraduationCap, Store, ArrowRight, CheckCircle2 } from "lucide-react";

const GUIAS = [
  {
    key: "red", label: "ConstruLink Red", Icon: Network, color: "#2563EB", to: "/conexion",
    resumen: "Conecta con profesionales, contratistas y ferreterías de la Familia ConstruLink.",
    pasos: [
      "Completa tu perfil profesional y tu portafolio para generar confianza.",
      "Publica tus servicios u oportunidades desde Red → Publicar.",
      "Busca miembros con filtros por rubro y ubicación.",
      "Inicia una conversación desde el perfil o la publicación.",
    ],
  },
  {
    key: "software", label: "Software", Icon: MonitorSmartphone, color: "#0891B2", to: "/software",
    resumen: "Adquiere y descarga software especializado para la construcción.",
    pasos: [
      "Explora el catálogo de software y revisa cada ficha.",
      "Realiza la compra con Mercado Pago de forma segura.",
      "Descarga desde Software → Mis descargas (acceso protegido).",
      "Consulta tu licencia y comprobantes en Pagos y Facturación.",
    ],
  },
  {
    key: "academia", label: "Academia", Icon: GraduationCap, color: "#7E22CE", to: "/academia",
    resumen: "Capacítate con cursos y obtén certificados verificables.",
    pasos: [
      "Inscríbete en un curso del catálogo de Academia.",
      "Avanza por las lecciones y sigue tu progreso gamificado.",
      "Completa el 100% para desbloquear tu certificado.",
      "Descarga tu certificado PDF en Academia → Mis certificados.",
    ],
  },
  {
    key: "marketplace", label: "Marketplace", Icon: Store, color: "#D97706", to: "/tienda",
    resumen: "Compra y vende productos digitales y cursos independientes.",
    pasos: [
      "Como comprador: agrega al carrito, acepta términos y paga.",
      "Accede a tus compras en «Mis Compras» y descarga el material.",
      "Como vendedor: crea tu tienda y publica productos/cursos.",
      "Gestiona ventas, comisiones y retiros desde tu panel.",
    ],
  },
];

export default function TutorialesPage() {
  return (
    <div className="px-5 md:px-8 py-8 max-w-5xl" data-testid="tutoriales-page">
      <Link to="/" className="inline-flex items-center gap-1 text-sm font-semibold text-slate-500 hover:text-slate-800">
        <ChevronLeft size={16} /> Volver al Ecosistema
      </Link>
      <h1 className="mt-4 text-3xl md:text-4xl font-extrabold text-slate-900 tracking-tight inline-flex items-center gap-3">
        <BookOpen size={30} style={{ color: "#7E22CE" }} /> Tutoriales
      </h1>
      <p className="mt-2 text-slate-600">Guías paso a paso para Red, Software, Academia y Marketplace.</p>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-6">
        {GUIAS.map((g) => {
          const Icon = g.Icon;
          return (
            <section key={g.key} className="bg-white rounded-2xl border border-slate-100 shadow-soft p-6 flex flex-col" data-testid={`tutorial-${g.key}`}>
              <div className="flex items-center gap-3">
                <span className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${g.color}15`, color: g.color }}><Icon size={24} /></span>
                <div>
                  <h2 className="text-lg font-extrabold text-slate-900">{g.label}</h2>
                  <p className="text-xs text-slate-500">{g.resumen}</p>
                </div>
              </div>
              <ol className="mt-4 space-y-2.5 flex-1">
                {g.pasos.map((p, i) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm text-slate-700">
                    <span className="mt-0.5 w-5 h-5 rounded-full flex items-center justify-center text-[11px] font-bold text-white flex-shrink-0" style={{ backgroundColor: g.color }}>{i + 1}</span>
                    {p}
                  </li>
                ))}
              </ol>
              <Link to={g.to} data-testid={`tutorial-ir-${g.key}`} className="mt-5 inline-flex items-center gap-2 font-semibold text-sm self-start hover:gap-3 transition-all" style={{ color: g.color }}>
                Ir a {g.label} <ArrowRight size={16} />
              </Link>
            </section>
          );
        })}
      </div>

      <div className="mt-8 rounded-2xl border border-slate-200 bg-gradient-to-br from-slate-50 to-white p-5 flex items-center gap-3">
        <CheckCircle2 size={20} className="text-emerald-500 flex-shrink-0" />
        <p className="text-sm text-slate-600">¿Necesitas más detalle? Visita el <Link to="/centro-ayuda" className="font-semibold text-slate-900 underline">Centro de Ayuda</Link> o escribe a Soporte.</p>
      </div>
    </div>
  );
}
